import { Routes } from '@angular/router'
import { hasPermissionGuard, requiresAdminGuard, requiresSupportGuard } from '../core/guards/has-permission.guard'
import { BoilerManagerFacadeService } from './features/widget-quote/boiler-manager/boiler-manager-facade.service'
import { Permissions } from '../core/permissions'

export const SECURE_ROUTES: Routes = [
    {
        path: 'access-denied',
        loadComponent: () =>
            import('./components/access-denied/access-denied.component').then((m) => m.AccessDeniedComponent),
        title: 'Access Denied',
    },
    {
        path: 'boiler-quote-manager',
        loadChildren: () => import('./features/widget-quote/routes').then((m) => m.BOILER_MANAGER_ROUTES),
        providers: [BoilerManagerFacadeService],
    },
    {
        path: 'leads',
        loadChildren: () => import('./features/leads/routes').then((m) => m.CUSTOMER_ROUTES),
    },
    {
        path: 'surequotes',
        loadChildren: () => import('./features/surequote/routes').then((m) => m.SUREQUOTE_ROUTES),
    },
    {
        path: 'quote-wizard',
        loadChildren: () => import('./features/quote-wizard/routes').then((m) => m.QUOTE_WIZARD_ROUTES),
        canActivate: [hasPermissionGuard],
        data: {
            permissions: [Permissions.QuoteWizard.View, Permissions.QuoteWizard.ViewOwn],
            requireAllPermissions: false,
        },
    },
    {
        path: 'media-library',
        loadChildren: () => import('./features/media/routes').then((m) => m.MEDIA_ROUTES),
    },
    {
        path: 'messaging',
        loadChildren: () => import('./features/messaging/routes').then((m) => m.MESSAGING_ROUTES),
    },
    {
        path: 'tickets',
        loadChildren: () => import('./features/tickets/routes').then((m) => m.TICKET_ROUTES),
    },
    {
        path: 'messages',
        loadChildren: () => import('./features/messages/routes').then((m) => m.MESSAGES_ROUTES),
    },
    {
        path: 'subscription',
        loadComponent: () =>
            import('./features/subscription/subscription.component').then((m) => m.SubscriptionComponent),
        title: 'Subscription',
        canActivate: [requiresAdminGuard],
    },
    {
        path: 'admin',
        loadChildren: () => import('./features/admin/routes').then((m) => m.ADMIN_ROUTES),
        canActivate: [requiresAdminGuard],
    },
    {
        path: 'support',
        loadChildren: () => import('./features/support/routes').then((m) => m.SUPPORT_ROUTES),
        canActivate: [requiresSupportGuard],
    },
    {
        path: 'billing',
        loadChildren: () => import('./features/support/billing/routes').then((m) => m.SUPPORT_BILLING_ROUTES),
        canActivate: [requiresSupportGuard],
    },
]
